import React, { useState, useEffect, useContext } from 'react';
import Button from 'b2b-ui-components-lib/lib/components/button';
import TextArea from 'b2b-ui-components-lib/lib/components/textarea';
import { stopBackgroundScrolling } from 'common/utils/app.utils';
import { fsCancelPopupOnLoad, fsCancelPopupOnSubmit, fsNeedAssistancePopupOnLoad, fsNeedAssistancePopupOnSubmit } from 'home/view/upgrade-order/utils';
import { CONTEXT } from 'home/view/upgrade-order/context';

import './index.scss';

const CancelModal = ({
  title = 'Cancel Order',
  subTitle = 'Are you sure you want to cancel the order? Please write the reason for cancellation.',
  label = 'Reason for cancellation',
  setshowPopup = () => {},
  onSubmit = () => {},
  loading = false,
  leadData = {}
}) => {
  const { userType } = useContext(CONTEXT);

  const [remarks, setRemarks] = useState('');
  const [submitDisabled, setSubmitDisabled] = useState(false);

  const isNeedAssistModal = title === 'Reason for Need Assistance';

  useEffect(() => {
    if (isNeedAssistModal) {
      fsNeedAssistancePopupOnLoad(leadData, userType);
    } else {
      fsCancelPopupOnLoad(leadData, userType);
    }
  }, [leadData, userType]);

  useEffect(() => {
    remarks ? setSubmitDisabled(false) : setSubmitDisabled(true);
  }, [remarks]);

  const hidePopup = () => {
    setshowPopup(false);
    stopBackgroundScrolling(false);
  };

  const handleSubmit = () => {
    onSubmit(remarks);
    if (isNeedAssistModal) {
      fsNeedAssistancePopupOnSubmit(leadData, userType, remarks);
    } else {
      fsCancelPopupOnSubmit(leadData, userType);
    }
  };

  return (
    <div className="drawerSection">
      <div className="popup-section cancelOrder">
        <h2>{title}</h2>
        <p
          style={{
            paddingBottom: subTitle ? 10 : 0
          }}
        >
          {subTitle}
        </p>
        <TextArea name="demo" label={label} placeholder="Enter Description" required value={remarks} onChange={(value) => setRemarks(value)} maxLength={150} />
        <div className="characters">&nbsp;</div>
        <div
          className="buttonSection"
          style={{
            justifyContent: 'flex-start',
            paddingTop: 15
          }}
        >
          <Button
            disabled={loading}
            variant="outlinebtn"
            onClick={hidePopup}
            style={{
              marginRight: 20,
              color: '#0C0F12',
              padding: 5
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={loading || submitDisabled}
            variant="activebtn"
            onClick={handleSubmit}
            style={{
              padding: 5
            }}
          >
            Submit
            {loading && <span className="loading_icon"></span>}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CancelModal;
